<template>
   <div class="modal modal-container modal-search modal-driver-birthday mainsearch fade" id="modalGetDriverBirthday" tabindex="-1" role="dialog" aria-labelledby="modalSearch"  data-backdrop="static" data-keyboard="false" >
      <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-lg" role="document">
         <div class="modal-content">
            <div class="modal-body">
               <button type="button" class="close" @click="close" data-dismiss="modal" aria-label="Close">
                     <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="40" height="40" fill="white"/>
                        <path d="M28 12L12 28" stroke="black" stroke-width="2"/>
                        <path d="M12 12L28 28" stroke="black" stroke-width="2"/>
                     </svg>
               </button>
               <div class="modal-search__heading">Оберіть дату народження водія</div>
               <div class="modal-search__list">
                   <form  @submit.prevent="send">
                       <div class="form">
                           <div class="row">
                               <div class="col-lg-12">
                                   <div class="form-group">
                                       <label>
                                           <span>Дата народження водія<i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip"  :data-original-title="tooltipContent" ></i><span class="required-icon">*</span></span>
                                       </label>
                                       <div :class="{'search-group' : true, 'datapicker-mask': true}">
                                           <date-picker v-model.trim="birthdayAt" :config="optionsBirthdyDate" :class="['date-input__dp','form-control', {invalid: (!$v.birthdayAt.minYears) || (!$v.birthdayAt.required && submitForm) }]" placeholder="Дата народження водія">
                                               <template #input>
                                                   <input
                                                       type="text"
                                                       class="form-control date-input__dp"
                                                       placeholder="Дата народження"
                                                   >
                                               </template>
                                           </date-picker>
                                           <small class="error"
                                                  v-if="!$v.birthdayAt.required && submitForm">Введіть дату народження водія</small>
                                           <small class="error" v-else-if="!$v.birthdayAt.minYears && submitForm">
                                               Водію повинно бути більше 18 років
                                           </small>

                                           <!-- Основные строки -->
                                           <div v-for="(descr, index) in visibleDescriptions" :key="index" class="form-group__descr">
                                               *Для СК "{{ descr.companyName }}" вкажіть {{ descr.description }},
                                           </div>

                                           <!-- Анимированное раскрытие -->
                                           <transition-group name="smooth-expand" tag="div">
                                               <div v-for="(descr, index) in hiddenDescriptions"
                                                    :key="'hidden-' + index"
                                                    class="form-group__descr">
                                                   *Для СК "{{ descr.companyName }}" вкажіть {{ descr.description }},
                                               </div>
                                           </transition-group>

                                           <!-- Кнопка для раскрытия -->
                                           <button type="button" v-if="descriptions.length > maxVisible" @click="toggleShowMore" class="toggle-btn">
                                               {{ showAll ? 'Приховати' : 'Показати ще' }}
                                               <span :class="{'arrow': true, 'rotate': showAll}">▼</span>
                                           </button>
                                       </div>
                                   </div>
                               </div>
                           </div>
                           <div class="row">
                               <div class="col-lg-12 insurance-nav d-flex justify-content-center">
                                   <button class="btn-blue-w" type="submit" :disabled="!checkErrors()">
                                       Застосувати
                                   </button>
                               </div>
                           </div>
                       </div>
                   </form>

               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
import { maxLength, minLength, numeric, required } from "vuelidate/lib/validators";
import Vue from "vue";

export default {
       data() {
           return {
               order: null,
               showAll: false,
               maxVisible: 2,
               descriptions: [],
               birthdayAt: null,
               submitForm: false,
               optionsBirthdyDate: {
                   format: 'DD.MM.YYYY',
                   useCurrent: false,
                   minDate: new Date(new Date().getFullYear() - 100, new Date().getMonth(), new Date().getDate()),
                   //maxDate: new Date(new Date().getFullYear() - 16, new Date().getMonth(), new Date().getDate()), // Доработать категория А с 16 лет, категория В,С с 18 лет, категория D с 21 года
                   maxDate: new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate()),
                   defaultDate: new Date(new Date().getFullYear() - 35, new Date().getMonth(), new Date().getDate()),
                   locale: 'uk',
                   icons: {
                       previous: 'icon arrow-point-to-left',
                       next: 'icon arrow-point-to-right',
                   },
               },
           };
       },
       created(){
          this.getCompanyDelails();
       },
       methods: {
           send(){
               return this.$emit('confirm-driver-birthday',this.birthdayAt);
           },
           close() {
               return this.$emit('close-driver-birthday', this.order);
           },
           open: function (order) {
               this.order = order;
           },
           getCompanyDelails() {
               axios.get('/api/company/get-details').then(({data}) => {
                   this.descriptions = data.data;
               }).catch(err => (console.log(err)));
           },
           toggleShowMore() {
               this.showAll = !this.showAll;
           },
           checkErrors() {
               if(!this.birthdayAt){
                   return false;
               }
               return true;
           }
       },
       validations: {
           birthdayAt: {required,minYears: (value) => {
                   if (value === null || !value) {
                       return  true
                   }
                   return (parseInt(moment(value, 'DD.MM.YYYY').diff(moment(), 'years')) * -1) > 17;
               }
           },
       },
       computed: {
           tooltipContent() {
               return `
              При заповненні цього поля необхідно вказати дату народження водія, який має найменший вік серед усіх водіїв даного ТЗ.<br><br>
              Якщо транспортний засіб використовують кілька водіїв, важливо врахувати, що:<br>
              <ul>
                ${this.descriptions.map(item => `<li>Для випадків, що стосуються СК '${item.companyName}' замість цього вказується ${ item.description }</li>`).join("")}
              </ul>
            `;
           },
           visibleDescriptions() {
               return this.descriptions.slice(0, this.maxVisible);
           },
           hiddenDescriptions() {
               return this.showAll ? this.descriptions.slice(this.maxVisible) : [];
           },
       }
   }
</script>
<style scoped>
    .modal-driver-birthday .modal-body {
        padding: 20px 10px 20px!important;
    }
    .mainsearch .form-group__descr {
        margin-bottom: 5px;
    }

    .modal-driver-birthday{
        padding-right: 0px!important;
    }


    /* Анимация плавного появления */
    .mainsearch .smooth-expand-enter-active, .smooth-expand-leave-active {
        transition: all 0.4s ease-in-out;
        opacity: 1;
        max-height: 100px;
    }
    .mainsearch .smooth-expand-enter,
    .mainsearch .smooth-expand-leave-to {
        opacity: 0;
        max-height: 0;
    }

    /* Кнопка */
    .mainsearch .toggle-btn {
        background: none;
        border: none;
        color: #007bff;
        cursor: pointer;
        font-size: 14px;
        margin-top: 5px;
        display: flex;
        align-items: center;
    }

    /* Стрелка */
    .mainsearch .arrow {
        margin-left: 5px;
        transition: transform 0.3s ease;
    }
    .mainsearch .rotate {
        transform: rotate(180deg);
    }
    .modal-driver-birthday .modal-dialog-lg{
        max-width: 600px;
    }
</style>
